export class CreateTradeTransactionsError extends Error {}
